<div class="title">Generated Invite</div>
<div class="information">
  <span>We've generated invite link for quick registration!</span>
  <span>Share the URL below to the Realtor for registration in Best Offer Package</span>
</div>

<label class="arb-input">
  <span class="title">URL</span>
  <input #url type="text" [value]="data.packageUrl" readonly>
  <mat-icon (click)="onCopy()" class="copy-icon" svgIcon="copy"></mat-icon>
</label>

<div class="actions">
  <button mat-flat-button class="close-button" mat-dialog-close>Close</button>
</div>